import editProfileSlice from './slice';

const editProfileReducer = editProfileSlice.reducer;

export default editProfileReducer;
